interface NumberSectionProps {
  number: number
  title: React.ReactNode
  subtitle?: React.ReactNode
  children?: React.ReactNode
  className?: string
}

export const NumberSection: React.FC<NumberSectionProps> = ({ number, title, children, subtitle, className }) => {
  return (
    <div className={`flex gap-4 ${className}`}>
      <div className="flex flex-col items-center gap-2">
        <div className="flex h-12 w-12 items-center justify-center rounded-full border-2 border-logo text-2xl font-bold text-logo">
          {number}
        </div>
        <div className="w-[3px] flex-grow rounded bg-gray-200" />
      </div>
      <div className="mt-2.5 flex flex-col gap-2">
        <div className="text-xl font-[500] leading-6">{title}</div>
        {subtitle && <div className="-mt-2">{subtitle}</div>}
        {children}
      </div>
    </div>
  )
}
